module.exports = __webpack_public_path__ + "static/chwingas-237813e692e843009e8d7708893acf99.jpg";